import React, {createContext, useCallback, useEffect, useState} from "react";
import {useDebounceState, useLocalStorage} from "../../utils/hooks.jsx";
import {NOOP} from "../../utils/NOOP.jsx";
import moment from "moment-timezone";

export const TableDateSearchContext = createContext({onClearDebouncedSearchText: NOOP, setUnDebouncedSearchText: NOOP});

export const TableDateSearchProvider = ({children, localStorageKey}) => {
    const [formValues, setFormValues] = useState({});
    const [debouncedSearchText, setUnDebouncedSearchText, unDebouncedSearchText] = useDebounceState("", 500);
    const [searchDate, setSearchDate] = useLocalStorage(
        localStorageKey,
        [moment().startOf("month"), moment().endOf("month")],
        ([start, end]) => [moment(start), moment(end)]
    );

    const [searchByCreated, setSearchByCreated] = useState(true);
    const [searchStatuses, setSearchStatuses] = useState([]);

    const onClearDebouncedSearchText = useCallback(() => {
        setUnDebouncedSearchText("");
    }, []);

    useEffect(() => {
        setFormValues(prev => ({
            ...prev,
            searchDate,
            searchByCreated,
            statuses: searchStatuses,
            searchText: debouncedSearchText
        }));
    }, [searchDate, searchByCreated, searchStatuses, debouncedSearchText]);

    return (
        <TableDateSearchContext.Provider
            value={{
                debouncedSearchText,
                setUnDebouncedSearchText,
                unDebouncedSearchText,
                onClearDebouncedSearchText,
                searchDate,
                setSearchDate,
                setSearchByCreated,
                searchByCreated,
                searchStatuses,
                setSearchStatuses,
                formValues,
                setFormValues
            }}>
            {children}
        </TableDateSearchContext.Provider>
    );
};
